import React from "react";
import { useNavigate } from "react-router-dom";
import "./css/transformationInstructions.css";
import useTranslation from "../hooks/useTranslation";

function TransformationInstructions({ gameData, updateProgress }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleStart = () => {
    updateProgress('transformation-instructions');
    console.log('Botón START presionado - Transformation con datos:', gameData);
    navigate('/game/transformation');
  };

  return (
    <div className="transformation-container">
      {/* Contenido central */}
      <div className="transformation-content">
        <div className="transformation-header">
          <h1 className="game-titleT">{t('transformationInstructions.gameTitle')}</h1>
          <h2 className="game-subtitleT">{t('transformationInstructions.gameSubtitle')}</h2>
        </div>

        <div className="instructions-box">
          <h2 className="instructions-title">{t('transformationInstructions.title')}</h2>
          <h3 className="instructions-subtitle">{t('transformationInstructions.subtitle')}</h3>
          
          <div className="instructions-text">
            <p>
              {t('transformationInstructions.paragraph1')}
            </p>
            
            <p>
              {t('transformationInstructions.paragraph2')}
            </p>
            
            <p>{t('transformationInstructions.paragraph3')}</p>
            
            <ul>
              <li>{t('transformationInstructions.listItem1')}</li>
              <li>{t('transformationInstructions.listItem2')}</li>
              <li>{t('transformationInstructions.listItem3')}</li>
            </ul>
            
            <p>
              {t('transformationInstructions.paragraph4')}
            </p>
            
            <p>
              {t('transformationInstructions.paragraph5')}
            </p>
          </div>

          <button className="start-button" onClick={handleStart}>
            {t('transformationInstructions.startButton')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default TransformationInstructions;

